import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import './helpers/getUserLocation';
import getOperatingSystem from './helpers/getOperatingSystem';
import generateUniqueBrowserId from './helpers/generateUniqueBrowserId';
import App from './App';
import store from './redux/store';

generateUniqueBrowserId();
getOperatingSystem();

ReactDOM.render(
  <Provider store={store}>
    <DndProvider backend={HTML5Backend}>
      <App />
    </DndProvider>
  </Provider>,
  document.getElementById('root'),
);

ReactDOM.render(
  <Provider store={store}>
    <DndProvider backend={HTML5Backend}>
      <App />
    </DndProvider>
  </Provider>,
  document.getElementById('root'),
);

if (window.Cypress) {
  window.store = store;
}
